import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { createGlobalStyle } from 'styled-components'
import CommonDropdown from '@components/common/CommonDropdown'
import CommonImage from '@components/common/CommonImage'
import CommonInput from '@components/common/CommonInput'
import CommonAvatar from '@components/common/CommonAvatar'
import CommonDivider from '@components/common/CommonDivider'
import PostTitle from '@components/post/PostTitle'
import IconText from '@components/post/IconText'
import { useHistory, useParams } from 'react-router'
import { searchApi } from '@api/api'

const SearchResultsPage = props => {
  const history = useHistory()
  const { option, keyword } = useParams()
  const [searchOption, setSearchOption] = useState('사용자')
  const [search, setSearch] = useState('')
  const [results, setResult] = useState([])

  const iconText = [
    { id: 1, icon: 'thumb', text: '93', color: '#FFA34B' },
    { id: 2, icon: 'comment', text: '10', color: '#FFA34B' },
  ]

  useEffect(() => {
    if (!option || !keyword) {
      return
    }

    const convertedOption = option === 'user' ? '사용자' : '게시글'
    setSearchOption(convertedOption)
    searchResult(option, keyword)
  }, [keyword])

  const searchResult = async (optionType, searchKeyword) => {
    const { resData } = await searchApi.searchAsAll(searchKeyword)

    setSearch(searchKeyword)
    setResult(
      resData.filter(data => (optionType === 'user' ? data.role : !data.role)),
    )
    history.push(`/search/${optionType}/${searchKeyword}`)
  }

  const onKeyPress = e => {
    if (e.key !== 'Enter') {
      return
    }
    const convertedOption = searchOption === '사용자' ? 'user' : 'posts'
    searchResult(convertedOption, search)
  }

  const onChangeOption = e => {
    const convertedOption = e.target.value === '사용자' ? 'user' : 'posts'

    setSearchOption(e.target.value)
    searchResult(convertedOption, search)
  }

  return (
    <>
      <UserSearchResultsPageStyle />
      <div className="dropdown-input">
        <CommonDropdown
          name="search"
          selectValue={searchOption}
          onChange={onChangeOption}
          options={[
            { text: '사용자', value: '사용자' },
            { text: '게시글', value: '게시글' },
          ]}
        />
        <CommonInput
          width={480}
          isSearch
          placeholder="검색어를 입력하세요!"
          value={search}
          onChange={e => setSearch(e.target.value)}
          onKeyPress={onKeyPress}
        />
      </div>
      <div>
        {searchOption === '사용자' &&
          results.map(result => (
            <div
              key={result._id}
              className="search-results pointer"
              aria-hidden
              onClick={() => history.push(`/user/${result._id}`)}>
              <CommonAvatar
                src={
                  result.image || require('../assets/images/404.png').default
                }
                width={200}
                height={70}
                fontSize={14}
                strong
                username={result.fullName}
                follower={
                  result.followers
                    ? `팔로워 ${result.followers.length}명`
                    : '0명'
                }
                style={{ cursor: 'pointer' }}
              />
            </div>
          ))}
        {searchOption === '게시글' &&
          results.map(result => (
            <div key={result._id} className="margin-top">
              <CommonImage
                src={
                  result.image ||
                  require('../assets/images/404_wide.png').default
                }
                className="pointer img-size"
                style={result.image ? null : { border: '1px solid #EAEBEC' }}
                onClick={() => history.push(`/post/detail/${result._id}`)}
              />
              <div className="flex">
                <PostTitle
                  className="pointer"
                  title={result.title}
                  createdAt={result.createdAt}
                  onClick={() => history.push(`/post/detail/${result._id}`)}
                />
                <div className="icon-text">
                  <IconText iconText={iconText} />
                </div>
              </div>
              <CommonDivider type="horizontal" />
            </div>
          ))}
      </div>
    </>
  )
}

SearchResultsPage.propTypes = {}

const UserSearchResultsPageStyle = createGlobalStyle`
.dropdown-input{
  display: flex;
  justify-content: space-between;
  margin: 50px 0px;
}
.search-results{
  margin-bottom: 40px;
}
.pointer {
  cursor: pointer;
}
.dropdown-input{
  display: flex;
  justify-content: space-between;
  margin: 50px 0px;
}
.margin-30{
    padding: 0 30px;
  }
.flex{
  display: flex;
  justify-content: space-between;
}
.icon-text{
  margin-top: 70px;
}
.margin-top{
    margin-top: 30px;
}
.img-size{
    width: 100%;
    height: 300px;
  }
`

export default SearchResultsPage
